import * as React from 'react';
import { Dispatch } from 'react-redux';
import { Translate, I18n } from 'react-redux-i18n';

import { StoreState } from '../../../reducers';
import Popup, { PopupTheme, FooterData } from '../../Popup';
import { PopupBodyWrapper } from './styles';
import { acquireLock } from '../../../containers/Editor/actions';
import RoutesUtils from '../../../utils/routes';

interface LockedEditorPopupProps {
	isDisplayed: boolean;
	userName: string;
	parentId: number;
	isProposal: boolean;
	dispatch: Dispatch<StoreState>;
}

const LockedEditorPopup = ({
	isDisplayed,
	userName,
	parentId,
	isProposal,
	dispatch,
}: LockedEditorPopupProps) => {
	const handleCancelClick = () => {
		RoutesUtils.redirectToParentDir(parentId);
	};

	const popupFooter: FooterData = {
		label: I18n.t('messages.unlock'),
		onAccept: () => dispatch(acquireLock()),
	};

	return (
		<Popup
			isDisplayed={isDisplayed}
			label={I18n.t('messages.notification')}
			onCancel={handleCancelClick}
			footer={popupFooter}
			theme={PopupTheme.DARK}
		>
			<PopupBodyWrapper>
				<Translate
					value={isProposal ? 'messages.proposal_locked' : 'messages.publication_locked'}
					userName={userName || I18n.t('messages.another_user').toLowerCase()}
				/>
			</PopupBodyWrapper>
		</Popup>
	);
};

export default LockedEditorPopup;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/LockedEditorPopup/index.tsx